import { createContext } from 'react';

const SideNavContext = createContext();

export default SideNavContext;